import React from 'react';
import PropTypes from 'prop-types';
import Button from '../Button';
import './styles.scss';

export const TYPE_DEFAULT = 'default';
export const TYPE_PRIMARY = 'primary';

export const ButtonCrud = ({ classNames = [], ...props }) => {
    const { type } = props;
    if (type === TYPE_DEFAULT) {
        classNames.push('custom-btn-crud-default');
    } else if (type === TYPE_PRIMARY) {
        classNames.push('custom-btn-crud-primary');
    }
    return <Button {...props} classNames={['custom-btn-crud', ...classNames]} />;
};

ButtonCrud.propTypes = {
    classNames: PropTypes.arrayOf(PropTypes.string),
    onClick: PropTypes.func,
    /* can be default or primary */
    type: PropTypes.string.isRequired,
    disabled: PropTypes.bool,
};
